export default __webpack_public_path__ + "static/assets/566d73a090e3d42d5bdfee3d92c79d25.svg";